import React from 'react';
import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="relative bg-[#1A1A1A] text-[#F5F3F0] pt-24 pb-12 border-t border-[#252525]" data-id="element-53">
      {/* Heavy timber texture */}
      <div className="absolute inset-0 texture-timber opacity-20" data-id="element-54" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-56">
          <div className="md:col-span-1" data-id="element-57">
            <img src="https://cdn.magicpatterns.com/uploads/rsVSuidRepyz9oxNYVg3rK/Iron_Ridge_Logo.png" alt="Iron Ridge Custom Homes" className="h-16 w-auto mb-4 brightness-[10] contrast-[0.9]" data-id="element-58" />
            <p className="text-[#D4CFC8]/60 text-sm leading-relaxed mb-6" data-id="element-59">
              Crafting bespoke homes that stand the test of time. Where heritage
              meets innovation in Northern Idaho.
            </p>
            <div className="flex gap-4" data-id="element-60">
              {[Instagram, Facebook, Linkedin, Twitter].map((Icon, i) => <a key={i} href="#" className="text-[#D4CFC8]/60 hover:text-[#A07656] transition-colors" data-id="element-61">
                  <Icon className="w-5 h-5" data-id="element-62" />
                </a>)}
            </div>
          </div>

          <div data-id="element-63">
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#A07656] mb-6" data-id="element-64">
              Explore
            </h4>
            <ul className="space-y-4 text-sm text-[#D4CFC8]/80" data-id="element-65">
              <li data-id="element-66">
                <a href="#" className="hover:text-white transition-colors" data-id="element-67">
                  Portfolio
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="hover:text-white transition-colors" data-id="element-69">
                  Process
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-white transition-colors" data-id="element-71">
                  About Us
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="hover:text-white transition-colors" data-id="element-73">
                  Journal
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-74">
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#A07656] mb-6" data-id="element-75">
              Contact
            </h4>
            <ul className="space-y-4 text-sm text-[#D4CFC8]/80" data-id="element-76">
              <li data-id="element-77">1247 E. Seltice Way</li>
              <li data-id="element-78">Post Falls, ID 83854</li>
              <li className="pt-2" data-id="element-79">
                <a href="tel:+12085550000" className="hover:text-white transition-colors" data-id="element-80">
                  +1 (208) 555-0000
                </a>
              </li>
              <li data-id="element-81">
                <a href="mailto:hello@ironridgecustomhomes.com" className="hover:text-white transition-colors" data-id="element-82">
                  hello@ironridgecustomhomes.com
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-1 flex flex-col justify-between" data-id="element-83">
            <div className="border-2 border-[#A07656]/30 p-6 text-center bg-[#252525]/50" data-id="element-84">
              <span className="block text-3xl font-serif font-bold text-[#A07656] mb-1" data-id="element-85">
                30+
              </span>
              <span className="text-xs uppercase tracking-widest text-[#D4CFC8]/60 font-medium" data-id="element-86">
                Years of Excellence
              </span>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#252525] flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#D4CFC8]/40" data-id="element-87">
          <p data-id="element-88">
            &copy; {new Date().getFullYear()} Iron Ridge Custom Homes. All
            rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-89">
            <a href="#" className="hover:text-[#D4CFC8]/80" data-id="element-90">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-[#D4CFC8]/80" data-id="element-91">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}